/* eslint-disable react/no-array-index-key */
// CategorySelectionModal.js
import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
  makeStyles,
  Grid,
  IconButton,
  Typography,
  Divider,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
  categoryModal: {
    minWidth: 400,
  },
  modalTitle: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(2),
  },
  btn: {
    borderRadius: "10px",
    padding: theme.spacing(1, 4),
    color: "#FFFFFF",
  },
  cancelBtn: {
    background: "linear-gradient(90.49deg, #373738 -0.38%, #565656 99.9%)",
    "&:hover": {
      background: "linear-gradient(90.49deg, #2c2c2d -0.38%, #484848 99.9%)",
    },
    border: "1px",
  },
  saveBtn: {
    background: "linear-gradient(90.49deg, #080C5C -0.38%, #080F8B 99.9%)",
    "&:hover": {
      background: "linear-gradient(90.49deg, #060A4A -0.38%, #060C76 99.9%)",
    },
  },
  header: {
    padding: theme.spacing(3, 4),
    minHeight: theme.spacing(8),
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: "1.5rem",
    color: theme.palette.text.primary,
  },
  actionButtons: {
    padding: theme.spacing(3, 4),
  },
  listItem: {
    fontSize: "1.5rem",
  },
}));

const CategorySelectionModal = ({
  open,
  onClose,
  availableCategories,
  selectedCategories,
  onCategoriesChange,
}) => {
  const classes = useStyles();
  const [tempSelectedCategories, setTempSelectedCategories] = useState([
    ...selectedCategories,
  ]);

  const handleToggleCategory = (category) => {
    if (tempSelectedCategories.includes(category)) {
      setTempSelectedCategories(
        tempSelectedCategories.filter((cat) => cat !== category)
      );
    } else {
      setTempSelectedCategories([...tempSelectedCategories, category]);
    }
  };

  const handleCancel = () => {
    setTempSelectedCategories([...selectedCategories]);
    onClose();
  };

  const handleConfirm = () => {
    const res = onCategoriesChange(tempSelectedCategories);
    if (res == null) {
      handleCancel();
      return;
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      aria-labelledby="category-selection-dialog-title"
      fullWidth
      maxWidth="sm"
    >
      <div className={classes.header}>
        <Grid
          container
          style={{ justifyContent: "space-between" }}
          alignItems="center"
          spacing={4}
        >
          <Grid item>
            <Typography
              className={classes.title}
              variant="h4"
              id="upload-document-modal"
            >
              Select Categories to Display
            </Typography>
          </Grid>
          <Grid item>
            <IconButton
              onClick={handleCancel}
              aria-label="close"
              // disabled={isUploading}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </div>
      <Divider />
      <DialogContent className={classes.categoryModal}>
        <List>
          {availableCategories.map((category, index) => (
            <ListItem
              key={index}
              button
              onClick={() => handleToggleCategory(category)}
            >
              <ListItemIcon>
                <Checkbox
                  color="primary"
                  edge="start"
                  checked={tempSelectedCategories.includes(category)}
                  tabIndex={-1}
                  disableRipple
                />
              </ListItemIcon>
              <ListItemText className={classes.listItem} primary={category} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <div className={classes.actionButtons}>
          <Grid container spacing={2}>
            <Grid item>
              <Button
                onClick={handleCancel}
                color="default"
                className={[classes.btn, classes.cancelBtn]}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <Button
                onClick={handleConfirm}
                color="primary"
                variant="contained"
                className={[classes.btn, classes.saveBtn]}
              >
                Confirm
              </Button>
            </Grid>
          </Grid>
        </div>
      </DialogActions>
    </Dialog>
  );
};

CategorySelectionModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  availableCategories: PropTypes.array.isRequired,
  selectedCategories: PropTypes.array.isRequired,
  onCategoriesChange: PropTypes.func.isRequired,
};

export default CategorySelectionModal;